import * as amplitude from '@amplitude/analytics-browser';

export const identifyUser = (userId: string) => {
  amplitude.setUserId(userId);
};

export const trackEvent = (event: string, properties?: Record<string, any>) => {
  amplitude.track(event, properties);
};
